import { render, staticRenderFns } from "./musteripersoneldialog.vue?vue&type=template&id=dfe8ca20&scoped=true"
import script from "./musteripersoneldialog.vue?vue&type=script&lang=js"
export * from "./musteripersoneldialog.vue?vue&type=script&lang=js"
import style0 from "./musteripersoneldialog.vue?vue&type=style&index=0&id=dfe8ca20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe8ca20",
  null
  
)

export default component.exports